import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Ids, setFormOpen } from "../reducers/rhapsody";
import { useVenue } from "../redux/venue/venueHooks";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/joy";
import { Cover } from "../hooks/cover/cover";
import { useContractors } from "../redux/contractor/contractorHooks";
import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { GigsDatagrid } from "../hooks/gigsDatagrid/gigsDatagrid";
import { RouterConfig } from "../hooks/config/routerConfig";
import { compatibleSources } from "../global";
import Calendar from "../hooks/calendar/calendar";
import { useDispatch } from "react-redux";
import { useGigs } from "../redux/gig/gigHooks";
import { VenueGeneral } from "../hooks/venueGeneral/venueGeneral";
import { proEnabled } from "../constants";

export function useVenueIDs(): Ids {
  const [searchParams] = useSearchParams();
  const sourceID = parseInt(searchParams.get("sourceID"));
  const sourceRecordID = parseInt(searchParams.get("sourceRecordID"));
  const id = parseInt(searchParams.get("id"));
  return { id, sourceID, sourceRecordID };
}

/**
 *
 * @returns {ReactElement} VenuePage page
 */
export function VenuePage() {
  const dispatch = useDispatch();
  const venueIDs = useVenueIDs();
  const { venue, isLoading } = useVenue(venueIDs);
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();
  const { contractors } = useContractors();
  const { gigs } = useGigs();

  const contractorID = gigs?.length ? gigs[0].contractorID : undefined;
  const contractor = contractors?.find(
    (e) =>
      compatibleSources(venue?.sourceID, venue?.sourceID) &&
      e.sourceRecordID == contractorID
  );

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        justifyContent: isLoading ? "center" : undefined,
        alignItems: isLoading ? "center" : undefined,
        // maxWidth: 1200,
        // background: "red",
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        p: 2,
      }}
    >
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "start" }}>
            <Button
              color="neutral"
              variant="soft"
              onClick={() => navigate(RouterConfig.venues)}
              startDecorator={<i className="fa-solid fa-chevron-left"></i>}
              size="sm"
            >
              Back
            </Button>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box>
                <Typography
                  startDecorator={
                    venue?.coverURL ? (
                      <img src={venue?.coverURL} height={18} />
                    ) : (
                      []
                    )
                  }
                  level="body2"
                  sx={{ fontWeight: 600 }}
                >
                  {venue?.city}
                </Typography>
                <Typography level="h5" sx={{ fontWeight: 600 }}>
                  {venue.name}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Tabs
              onChange={(e, v) => setCurrentTab(v)}
              value={currentTab}
              variant="scrollable"
              sx={{ width: "100%" }}
            >
              <Tab sx={{ textTransform: "none" }} value={0} label="Services" />
              <Tab sx={{ textTransform: "none" }} value={1} label="Calendar" />
              <Tab sx={{ textTransform: "none" }} value={2} label="General" />
            </Tabs>
            <Divider />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              width: "calc(100vw - 32px)",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {currentTab === 0 ? (
              <>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  {proEnabled ? (
                    <Button
                      onClick={() => {
                        dispatch(setFormOpen({ isOpen: true, formID: "gig" }));
                      }}
                      size="sm"
                      color="info"
                    >
                      + New Service
                    </Button>
                  ) : (
                    []
                  )}
                </Box>

                <GigsDatagrid venueID={venue.sourceRecordID} />
              </>
            ) : (
              []
            )}
            {currentTab === 1 ? (
              <Calendar
                venueID={venue.sourceRecordID}
                disableCreate={venue.sourceID !== 420}
              />
            ) : (
              []
            )}
            {currentTab === 2 ? <VenueGeneral /> : []}
          </Box>
        </Box>
      )}
    </Box>
  );
}
